$ = require 'jquery'
{ Analytics } = require '@trello/atlassian-analytics'
{ track, trackUe } = require '@trello/analytics'

Auth = require 'app/scripts/db/auth'
MemberBoardProfileView = require 'app/scripts/views/member/member-board-profile-view'
Dialog = require 'app/scripts/views/lib/dialog'
Controller = require 'app/scripts/controller'
PopOver = require 'app/scripts/views/lib/pop-over'
MemberOnBoardView = require 'app/scripts/views/member-menu-profile/member-on-board-view'
DragSort = require 'app/scripts/views/lib/drag-sort'
Util = require 'app/scripts/lib/util'
DragSort = require 'app/scripts/views/lib/drag-sort'
BoardHeaderAllMembersView = require 'app/scripts/views/board/board-header-all-members-view'
{ maybeDisplayMemberLimitsError } = require 'app/scripts/views/board-menu/member-limits-error'
BoardMemberAddMultipleView = require 'app/scripts/views/board-menu/board-member-add-multiple-view'

MAX_FACEPILE_SIZE = 5

module.exports.onMemberAdd = ->
  @renderBoardHeaderFacepileDebounced()

module.exports.renderBoardHeaderFacepile = ->
  $target = @$('.js-fill-facepile')
  visibleMembers = @model.orderedVisibleMembers()
  numMembers = visibleMembers.length
  visibleMembers = visibleMembers.slice(0, MAX_FACEPILE_SIZE)
  overflowMemberCount = numMembers - MAX_FACEPILE_SIZE

  if overflowMemberCount > 0
    @$('.js-fill-board-member-count').text('+' + overflowMemberCount)
  else
    @$('.js-fill-board-member-count').text('')

  subviews = for member in visibleMembers
    @subview(MemberOnBoardView, member, { board: @model })

  if $target.length > 0
    @ensureSubviews(subviews.reverse(), $target)

  @defer =>
    # Disallow adding members to cards from facepile when board is in template mode
    if !@model.isTemplate()
      DragSort.refreshDraggableSidebarMembers()

    @renderPopovers()

  @

module.exports.openAllMembers = (e) ->
  # activated only when there's member overflow from facepile
  Util.stop(e)

  trackUe('board view', 'opens', 'board members breakdown', '', '', 'board-header-button', BoardHeaderAllMembersView)
  if @sendGASEvent
    Analytics.sendUIEvent
      action: 'clicked'
      actionSubject: 'button'
      actionSubjectId: 'allBoardMembersButton'
      source: 'boardScreen'

  newInvitees = @getNewlySignedUpInvitees()

  PopOver.toggle
    elem: @$('.js-open-show-all-board-members')
    view: BoardHeaderAllMembersView
    options: {
      @model,
      @modelCache,
      newInvitees
    }

module.exports.openAddMembers = (e) ->
  Util.stop(e)
  if maybeDisplayMemberLimitsError($(e.target), @model)
    return
  trackUe('board view', 'adds', 'board member', '', '', 'board-header-button', BoardMemberAddMultipleView)
  if @sendGASEvent
    Analytics.sendUIEvent
      action: 'clicked'
      actionSubject: 'button'
      actionSubjectId: 'inviteToBoardButton'
      source: 'boardScreen'

  view = new BoardMemberAddMultipleView({ @model, @modelCache })
  view.loadOrgData()

  PopOver.toggle
    elem: $(e.target).closest('.js-open-manage-board-members')
    view: view

  return

module.exports.joinBoard = (e) ->
  Util.stop(e)
  if @sendGASEvent
    Analytics.sendUIEvent
      action: 'clicked'
      actionSubject: 'button'
      actionSubjectId: 'joinBoardButton'
      source: 'boardScreen'

  if maybeDisplayMemberLimitsError($(e.target), @model, Auth.me())
    return
  @$('.js-join-board').remove()
  @model.joinBoard()

  track("Board Menu", "Join Board via Header")
  if @sendCoreGASEvent
    Analytics.sendTrackEvent
      action: 'joined'
      actionSubject: 'board'
      source: 'boardScreen'
      containers:
        board:
          id: @model.id
        organization:
          id: @model.getOrganization()?.id || ''

  return

module.exports.showMemberProfile = (member) ->
  Controller.saveMemberBoardProfileLocation(member, @model.id)

  Dialog.show
    view: new MemberBoardProfileView({ model: member, board: @model, @modelCache })
    maxWidth: 500
    hide: =>
      Controller.setBoardLocation(@model.id)
  return
